import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-04c8e436"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card-body card-scroll" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "table table-row-dashed table-row-gray-300 gs-0 gy-4" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder text-muted" }, [
    /*#__PURE__*/_createElementVNode("th", null, "کاربر | پیام"),
    /*#__PURE__*/_createElementVNode("th", null, "پاسخگوی‌خودکار | پاسخ")
  ])
], -1))
const _hoisted_5 = { class: "w-md-50" }
const _hoisted_6 = { class: "d-flex flex-column box" }
const _hoisted_7 = { class: "d-flex align-items-center" }
const _hoisted_8 = { class: "symbol symbol-40px symbol-circle ms-2" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "d-flex justify-content-start flex-column" }
const _hoisted_11 = { class: "mb-1 fs-7" }
const _hoisted_12 = { class: "text-muted fw-bold d-block fs-7" }
const _hoisted_13 = { class: "m-2 d-flex flex-column" }
const _hoisted_14 = {
  class: "border border-1 border-gray-300 bg-light rounded fs-7 p-3",
  style: {"width":"fit-content","white-space":"pre-wrap"}
}
const _hoisted_15 = { class: "w-md-50" }
const _hoisted_16 = { class: "d-flex flex-column box" }
const _hoisted_17 = { class: "d-flex justify-content-between ms-2" }
const _hoisted_18 = {
  key: 0,
  class: "d-flex align-items-center"
}
const _hoisted_19 = { class: "d-flex justify-content-start flex-column ms-2" }
const _hoisted_20 = { class: "mb-1 fs-7" }
const _hoisted_21 = { class: "text-muted fw-bold d-block fs-7" }
const _hoisted_22 = {
  key: 1,
  class: "d-flex justify-content-start flex-column"
}
const _hoisted_23 = { class: "mb-1 fs-7" }
const _hoisted_24 = { class: "text-muted fw-bold d-block fs-7" }
const _hoisted_25 = { class: "table-responsive border border-1 border-dashed border-gray-400 bg-light-success rounded" }
const _hoisted_26 = {
  key: 0,
  class: "table table-row-dashed table-row-gray-300 align-middle gs-0 gy-2"
}
const _hoisted_27 = { class: "px-5" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bullet bg-primary me-1 text-end" }, null, -1))
const _hoisted_29 = {
  key: 0,
  class: "text-end mt-3"
}
const _hoisted_30 = {
  class: "d-flex justify-content-center flex-stack flex-wrap",
  dir: "ltr"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Date = _resolveComponent("Date")!
  const _component_platform = _resolveComponent("platform")!
  const _component_UserAvatar = _resolveComponent("UserAvatar")!
  const _component_FileViewer = _resolveComponent("FileViewer")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([_ctx.widgetClasses, "card"])
  }, [
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
      (_ctx.list && _ctx.list.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("table", _hoisted_3, [
              _hoisted_4,
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item, index) => {
                  return (_openBlock(), _createElementBlock("tr", { key: index }, [
                    _createElementVNode("td", _hoisted_5, [
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, [
                          _createElementVNode("div", _hoisted_8, [
                            (item.chat.avatar)
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 0,
                                  src: item.chat.avatar,
                                  alt: ""
                                }, null, 8, _hoisted_9))
                              : (_openBlock(), _createElementBlock("span", {
                                  key: 1,
                                  class: _normalizeClass([`bg-light-primary text-primary`, "symbol-label fs-6 fw-bolder"])
                                }, "ن"))
                          ]),
                          _createElementVNode("div", _hoisted_10, [
                            _createElementVNode("span", _hoisted_11, _toDisplayString(item.chat.chat_id), 1),
                            _createElementVNode("span", _hoisted_12, [
                              _createVNode(_component_Date, {
                                date: item.send_at
                              }, null, 8, ["date"])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_13, [
                          _createElementVNode("div", _hoisted_14, _toDisplayString(item.message), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("td", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("div", _hoisted_17, [
                          _createVNode(_component_platform, {
                            class: "ms-1",
                            platform: item.bot_platform.platform,
                            avatar: item.bot_platform.avatar,
                            logo: item.bot_platform.platform_avatar,
                            number: item.bot_platform.platform_number,
                            status: item.bot_platform.status,
                            secretary: item.bot_platform.enable_secretary,
                            botId: item.bot_platform.bot_id,
                            "package-support": true,
                            "show-btns": false,
                            online: "yes"
                          }, null, 8, ["platform", "avatar", "logo", "number", "status", "secretary", "botId"]),
                          (item.bot && item.bot.user)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                _createVNode(_component_UserAvatar, {
                                  avatar: item.bot.user.picture,
                                  size: "25px",
                                  id: item.bot.user.id
                                }, null, 8, ["avatar", "id"]),
                                _createElementVNode("div", _hoisted_19, [
                                  _createElementVNode("span", _hoisted_20, _toDisplayString(item.bot.user.first_name) + " " + _toDisplayString(item.bot.user.last_name), 1),
                                  _createElementVNode("span", _hoisted_21, _toDisplayString(item.bot.user.mobile), 1)
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (item.bot)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                _createElementVNode("span", _hoisted_23, _toDisplayString(item.bot.name), 1),
                                _createElementVNode("span", _hoisted_24, _toDisplayString(item.bot.bot_id), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_25, [
                          (item.response)
                            ? (_openBlock(), _createElementBlock("table", _hoisted_26, [
                                _createElementVNode("tbody", null, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.response, (response, j) => {
                                    return (_openBlock(), _createElementBlock("tr", { key: j }, [
                                      _createElementVNode("td", _hoisted_27, [
                                        _hoisted_28,
                                        _createTextVNode(_toDisplayString(response.text) + " ", 1),
                                        (response.file)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                              _createVNode(_component_FileViewer, {
                                                file: item.file,
                                                type: item.type
                                              }, null, 8, ["file", "type"])
                                            ]))
                                          : _createCommentVNode("", true)
                                      ])
                                    ]))
                                  }), 128))
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ])
                  ]))
                }), 128))
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])), [
      [_directive_loading, _ctx.loading]
    ]),
    _createElementVNode("div", _hoisted_30, [
      (_ctx.pagination && _ctx.pagination.total_pages > 1)
        ? (_openBlock(), _createBlock(_component_el_pagination, {
            key: 0,
            background: "",
            layout: "prev, pager, next",
            class: "mt-4 mb-4",
            total: _ctx.pagination.total,
            currentPage: _ctx.pagination.current_page,
            "page-size": _ctx.pagination.per_page,
            onCurrentChange: _ctx.handleCurrentChange
          }, null, 8, ["total", "currentPage", "page-size", "onCurrentChange"]))
        : _createCommentVNode("", true)
    ])
  ], 2))
}